/** Daily close (night audit) screen. */
export const laoHotelDailyClose: Record<string, string> = {
  'Night audit': 'ກວດປິດບັນຊີປະຈຳວັນ',
  'Business date': 'ວັນທຸລະກິດ',
  'Go to business date': 'ໄປຫາວັນທຸລະກິດ',
  'Go to': 'ໄປຫາ',
  'day open': 'ວັນທີ່ຍັງບໍ່ປິດ',
  'days open': 'ວັນທີ່ຍັງບໍ່ປິດ',
  'All completed days are closed': 'ປິດທຸກວັນທີ່ຜ່ານມາແລ້ວ',
  'Days to close': 'ວັນທີ່ຕ້ອງປິດ',
  Closed: 'ປິດແລ້ວ',
  'Close earlier days first': 'ປິດວັນກ່ອນໜ້າກ່ອນ',
  'Close the earlier open days first, oldest day first':
    'ປິດວັນກ່ອນໜ້າທີ່ຍັງເປີດຢູ່ກ່ອນ ເລີ່ມຈາກວັນເກົ່າສຸດ',
  'Close a completed day in Vientiane time': 'ປິດໄດ້ສະເພາະວັນທີ່ຜ່ານໄປແລ້ວຕາມເວລາວຽງຈັນ',
  'Days close in order. The next day to close is': 'ປິດວັນຕາມລຳດັບ. ວັນຕໍ່ໄປທີ່ຕ້ອງປິດແມ່ນ',
  'Resolve each arrival, and check out or extend each departure.':
    'ແກ້ໄຂການມາຮອດແຕ່ລະລາຍການ, ແລະ ບັນທຶກອອກ ຫຼື ຕໍ່ການພັກສຳລັບແຂກທີ່ຈະອອກ.',
  'to resolve': 'ລາຍການຕ້ອງແກ້ໄຂ',
  Waiting: 'ລໍຖ້າ',
  'Arrivals not checked in': 'ແຂກມາຮອດທີ່ຍັງບໍ່ໄດ້ເຂົ້າພັກ',
  'Departures not checked out': 'ແຂກທີ່ຄວນອອກແຕ່ຍັງບໍ່ໄດ້ບັນທຶກອອກ',
  'Bookings due on or before this day. Confirm or cancel pending arrivals.':
    'ການຈອງທີ່ຄວນມາຮອດພາຍໃນວັນນີ້. ຢືນຢັນ ຫຼື ຍົກເລີກການຈອງທີ່ຍັງລໍຖ້າ.',
  'Confirm or cancel this reservation': 'ຢືນຢັນ ຫຼື ຍົກເລີກການຈອງນີ້',
  'A daily close already reported this arrival. Undo check-in is unavailable.':
    'ປິດວັນທີ່ລາຍງານການມາຮອດນີ້ແລ້ວ. ບໍ່ສາມາດຍ້ອນການເຂົ້າພັກໄດ້.',
  'A daily close already reported this departure. Undo check-out is unavailable.':
    'ປິດວັນທີ່ລາຍງານການອອກນີ້ແລ້ວ. ບໍ່ສາມາດຍ້ອນການອອກໄດ້.',
  'In-house stays due to leave on or before this day.': 'ແຂກພັກຢູ່ທີ່ຄວນອອກພາຍໃນວັນນີ້.',
  'Select all': 'ເລືອກທັງໝົດ',
  Guest: 'ແຂກ',
  Actions: 'ການດຳເນີນການ',
  'Settle folio': 'ຊຳລະບັນຊີແຂກ',
  Extend: 'ຕໍ່ການພັກ',
  Settled: 'ຊຳລະແລ້ວ',
  'Not settled': 'ຍັງບໍ່ຊຳລະ',
  'day late': 'ວັນຊ້າ',
  'days late': 'ວັນຊ້າ',
  'All arrivals are checked in or resolved.': 'ແຂກມາຮອດທັງໝົດເຂົ້າພັກ ຫຼື ແກ້ໄຂແລ້ວ.',
  'All departures are checked out or extended.': 'ແຂກທີ່ຈະອອກທັງໝົດບັນທຶກອອກ ຫຼື ຕໍ່ການພັກແລ້ວ.',
  'These arrivals need a new room before overstays can be extended.':
    'ແຂກມາຮອດເຫຼົ່ານີ້ຕ້ອງຍ້າຍຫ້ອງໃໝ່ ກ່ອນຕໍ່ການພັກເກີນກຳນົດ.',
  'Day summary': 'ສະຫຼຸບປະຈຳວັນ',
  'Saved snapshot': 'ບັນທຶກທີ່ລັອກແລ້ວ',
  'Live preview': 'ຕົວຢ່າງປັດຈຸບັນ',
  ADR: 'ລາຄາສະເລ່ຍຕໍ່ຫ້ອງ (ADR)',
  RevPAR: 'ລາຍຮັບຕໍ່ຫ້ອງທີ່ມີ (RevPAR)',
  'Average daily rate': 'ລາຄາຫ້ອງສະເລ່ຍຕໍ່ຄືນ',
  'Revenue per available room': 'ລາຍຮັບຕໍ່ຫ້ອງທີ່ພ້ອມຂາຍ',
  'Room revenue': 'ລາຍຮັບຄ່າຫ້ອງ',
  'Rooms sold': 'ຫ້ອງທີ່ຂາຍໄດ້',
  'No-shows': 'ບໍ່ມາເຂົ້າພັກ',
  'Guests in house': 'ແຂກພັກຢູ່',
  'Out of order': 'ຫ້ອງປິດບໍລິການ',
  'Handover for the next shift (optional)': 'ຂໍ້ຄວາມສົ່ງຕໍ່ໃຫ້ກະຕໍ່ໄປ (ບໍ່ບັງຄັບ)',
  'Marked as no-show': 'ໝາຍວ່າບໍ່ມາເຂົ້າພັກແລ້ວ',
  'No-show fees follow each booking’s cancellation policy.':
    'ຄ່າທຳນຽມບໍ່ມາເຂົ້າພັກ ຄິດຕາມນະໂຍບາຍຍົກເລີກຂອງແຕ່ລະການຈອງ.',
  'Guest did not arrive': 'ແຂກບໍ່ມາຮອດ',
  'Saving…': 'ກຳລັງບັນທຶກ…',
};
